import { render, staticRenderFns } from "./TransactionInReview.vue?vue&type=template&id=7986ccad&"
import script from "./TransactionInReview.vue?vue&type=script&lang=js&"
export * from "./TransactionInReview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports